import React from "react";
import { EuiProvider } from "@elastic/eui";
import { Home } from "./components/home";

export const App: React.FC = () => {
  return (
    <EuiProvider>
      <div className="App-container">
        <Home />
      </div>
    </EuiProvider>
  );
};
